function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14 10V2L21 6L14 10Z",
  stroke: "#F8F8F8",
  strokeWidth: 0.870968
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 6 A9.5 9.5 0 1 0 22.217514421 8.782485579",
  fill: "none",
  strokeWidth: 2,
  id: "circle"
});
const Svg31PxNarrow = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: 31,
  height: 31,
  viewBox: "0 0 31 31",
  fill: "none",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = React.forwardRef((props, ref) => React.createElement(Svg31PxNarrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/31px-narrow.b1054803.svg";
export { ForwardRef as ReactComponent };